import { Link } from 'react-router-dom';
import styled from 'styled-components';

const StyledLink = styled(Link)`
  text-decoration: underline;
  font-size: ${({ theme, size = 12 }) => theme.utils.pxToRem(size)}rem;
  color: ${({ theme, disabled }) =>
    disabled ? theme.colors.mediumGray : theme.colors.defaultActionBlue};
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
`;

export default StyledLink;
